import { enableMapSet } from 'immer';
import { DispatchEvent, ObjectWithKeys, State } from './SmartTypes';
enableMapSet();

const smartReducer = (state: State, action: DispatchEvent) => {

};

export default smartReducer;
